<!-- AI:
Status: 'in progress'
Type: Component
SubType: ObjectBaseComponent
Reason: Dispatcher template of the lg.LogicMappingTable object component — side view in the drawer,
        full view everywhere else.
-->

@if (initialized && dto) {

    @if (uiMode == 'side' || uiMode == 'mini-side') {
        <mvs-lg-logic-mapping-table-object-component-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
                (onBreadcrumbItems)="handleBreadcrumbItems($event)">
        </mvs-lg-logic-mapping-table-object-component-side>
    } @else {
        <mvs-lg-logic-mapping-table-object-component-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
                (onBreadcrumbItems)="handleBreadcrumbItems($event)">
        </mvs-lg-logic-mapping-table-object-component-full>
    }

}
